module.exports = __webpack_public_path__ + "static/media/PlasticSurgery.431ff7c6.svg";